import { render, staticRenderFns } from "./LocalTenant.vue?vue&type=template&id=1275df78&scoped=true"
import script from "./LocalTenant.vue?vue&type=script&lang=js"
export * from "./LocalTenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1275df78",
  null
  
)

export default component.exports